import React from 'react';

import * as api from './dataProvider';
import { getUrlParams, setUrlParams } from '../../utils';
import { App } from '../../components';

export class AppContainer extends React.Component {
  params = getUrlParams();

  state = {
    isLoading: false,
    tickets: null,
    sales: null,
    entityData: undefined,
    selectedItem: null,
  };

  findEntityById(entities, id) {
    return entities.data.find(entity => entity.id === id);
  }

  async fetchSaleData() {
    if (this.params.id) {
      this.setState({ isLoading: true });
    }

    const [sales, entityData] = await Promise.all(
      [
        this.fetchAllSales(),
        this.params.id ? this.fetchSalesById(this.params.id) : null,
      ].filter(Boolean),
    );

    if (this.params.id) {
      this.setState({
        isLoading: false,
        selectedItem: this.findEntityById(sales, this.params.id),
        entityData,
      });
    }
  }

  async fetchTicketData() {
    if (this.params.id) {
      this.setState({ isLoading: true });
    }

    const [tickets, entityData] = await Promise.all(
      [
        this.fetchAllTickets(),
        this.params.id ? this.fetchTicketsById(this.params.id) : null,
      ].filter(Boolean),
    );

    if (this.params.id) {
      this.setState({
        isLoading: false,
        selectedItem: this.findEntityById(tickets, this.params.id),
        entityData,
      });
    }
  }

  async componentDidMount() {
    if (this.params.type === 'sale') {
      this.fetchSaleData();
    }

    if (this.params.type === 'ticket') {
      this.fetchTicketData();
    }
  }

  handleItemClick = item => {
    if (this.state.selectedItem && item.id === this.state.selectedItem.id) {
      return;
    }

    if (item.type === 'sale') {
      this.setState({ isLoading: true });
      this.fetchSalesById(item.id).then(() =>
        this.setState({ isLoading: false }),
      );
    }

    if (item.type === 'ticket') {
      this.setState({ isLoading: true });
      this.fetchTicketsById(item.id).then(() =>
        this.setState({ isLoading: false }),
      );
    }

    setUrlParams(item.type, item.id);
    this.setState({ selectedItem: item });
  };

  fetchAllTickets = async () => {
    const tickets = await api.fetchAllTickets();
    this.setState({ tickets });
    return tickets;
  };

  fetchAllSales = async () => {
    const sales = await api.fetchAllSales();
    this.setState({ sales });
    return sales;
  };

  fetchTicketsById = async id => {
    const ticketData = await api.fetchTicketsById(id);
    this.setState({ entityData: ticketData });
    return ticketData;
  };

  fetchSalesById = async id => {
    const saleData = await api.fetchSalesById(id);
    this.setState({ entityData: saleData });
    return saleData;
  };

  render() {
    return (
      <App
        isLoading={this.state.isLoading}
        tickets={this.state.tickets}
        sales={this.state.sales}
        entityData={this.state.entityData}
        selectedItem={this.state.selectedItem}
        handleItemClick={this.handleItemClick}
        fetchAllTickets={this.fetchAllTickets}
        fetchAllSales={this.fetchAllSales}
        fetchTicketsById={this.fetchTicketsById}
        fetchSalesById={this.fetchSalesById}
      />
    );
  }
}
